'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _components = require('../../../components');
var _OMTwinInputRow = require('./OMTwinInputRow.scss');var styles = _interopRequireWildcard(_OMTwinInputRow);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMTwinInputRow = function OMTwinInputRow(_ref) {var label = _ref.label,icon = _ref.icon,isMobile = _ref.isMobile,field = _ref.field,minTitle = _ref.minTitle,maxTitle = _ref.maxTitle,minPlaceholder = _ref.minPlaceholder,
  maxPlaceholder = _ref.maxPlaceholder,checkMaxValue = _ref.checkMaxValue,className = _ref.className,separator = _ref.separator;return (
    _react2.default.createElement('div', { className: styles.rowWrapper },
      _react2.default.createElement(_components.OMFiltersTitle, { label: label, icon: icon, isMobile: isMobile, className: styles.titleWrapper }),

      _react2.default.createElement(_components.OMTwinInput, {
        field: field,
        checkMaxValue: checkMaxValue,
        className: className,
        minTitle: minTitle,
        maxTitle: maxTitle,
        minPlaceholder: minPlaceholder,
        maxPlaceholder: maxPlaceholder,
        separator: separator })));};




OMTwinInputRow.propTypes = {
  label: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  field: _propTypes2.default.object,
  minTitle: _propTypes2.default.string,
  maxTitle: _propTypes2.default.string,
  minPlaceholder: _propTypes2.default.string,
  maxPlaceholder: _propTypes2.default.string,
  checkMaxValue: _propTypes2.default.func,
  className: _propTypes2.default.string,
  separator: _propTypes2.default.string };exports.default =


OMTwinInputRow;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTwinInputRow/OMTwinInputRow.js
// module id = 2779
// module chunks = 0